import {
  BeforeYouStartTemplate,
  BodyContentProps,
  ContentBody,
} from '@templates';
import { useNavigate } from 'react-router-dom';
import {
  CallToActionCardProps,
  InformationBox,
} from '@molecules/CallToActionCard/CallToActionCard';
import { v4 as uuidv4 } from 'uuid';
import {
  resetIssueDetails,
  resetUserDetails,
  useAnimalNuisanceStore,
} from '@animal-nuisance/hooks/useAnimalNuisanceStore';
import { RoutesList } from '@animal-nuisance/routes/Routes';
import { beforeYouStartContent } from '@animal-nuisance/constants/questionData';
import {
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_TEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

const BeforeYouStartContent = ({
  bodyContent,
}: {
  bodyContent: BodyContentProps['content'];
}) => {
  return (
    <div className="flex flex-col gap-8">
      <ContentBody content={bodyContent} />
      <InformationBox
        infoText={beforeYouStartContent.infoBox.description}
        variant="info"
        title=""
        data-testid="info-box"
      />
    </div>
  );
};

export const BeforeYouStartPage = () => {
  const navigate = useNavigate();
  const { update } = useAnimalNuisanceStore();

  const contentTitle = `Report an animal or dog nuisance`;
  const sessionId = uuidv4();
  const initiateForm = () => {
    resetUserDetails();
    resetIssueDetails();
    update('wantConfirmationEmail', null);
    update('caseReferenceId', '');
    update('sessionId', sessionId);
    navigate(RoutesList.REPORT_TYPE);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,

    onClick: initiateForm,
  };

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=animal_or_dog_nuisance`;
  const reportItAssistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const callToActionCards = [reportItAssistantCTA, reportItCTA];

  const { needToKnowItems, usefulToInclude, linkObjectArrays, infoBox } =
    beforeYouStartContent;
  const bodyContent = [needToKnowItems, usefulToInclude];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<BeforeYouStartContent bodyContent={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
